import { ColumnTypeEnum } from '@y42/json-schema';

export { ColumnTypeEnum };

export const NumberTypes: ColumnTypeEnum[] = [ColumnTypeEnum.Numeric, ColumnTypeEnum.Float, ColumnTypeEnum.Integer];
export const DateTypes: ColumnTypeEnum[] = [
  ColumnTypeEnum.Datetime,
  ColumnTypeEnum.Date,
  ColumnTypeEnum.Time,
  ColumnTypeEnum.Timestamp,
];
export const StrictDateTypes: ColumnTypeEnum[] = [
  ColumnTypeEnum.Datetime,
  ColumnTypeEnum.Date,
  ColumnTypeEnum.Timestamp,
];
export const BooleanTypes: ColumnTypeEnum[] = [ColumnTypeEnum.Boolean];
export const ArrayTypes: ColumnTypeEnum[] = [ColumnTypeEnum.Array, ColumnTypeEnum.ArrayString];

export function isNumberColumn(columnType: ColumnTypeEnum): boolean {
  return NumberTypes.includes(columnType);
}

export function isDateColumn(columnType: ColumnTypeEnum): boolean {
  return DateTypes.includes(columnType);
}
export function isStrictDateColumn(columnType: ColumnTypeEnum): boolean {
  return StrictDateTypes.includes(columnType);
}

export function isBooleanColumn(columnType: ColumnTypeEnum): boolean {
  return BooleanTypes.includes(columnType);
}

export function isArrayColumn(columnType: ColumnTypeEnum): boolean {
  return ArrayTypes.includes(columnType);
}
